import styled from "styled-components";

export const StyledFaqsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  padding: 64px 0px;

  max-width: 375px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 565px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 684px;
  }
`;

export const FaqsSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px 24px;
`;

export const StyledFaqsItem = styled.div`
  width: 100%;
  border-bottom: 1px solid #f3f3f6;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  &:only-child {
    border: none;
  }
  &:last-child {
    border-bottom: none;
  }

  margin-bottom: 9px;
`;

export const StyledFaqsTitle = styled.div`
  align-self: center;
  font-family: ThemeFontBold;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  padding-bottom: 24px;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const FaqHeader = styled.span`
  font-family: ThemeFontBold;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const FaqContent = styled.span`
  font-family: ThemeFontRegular;
  color: ${({ theme }) => theme.customTheme.palette.grey.light5E};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: 16px;
    line-height: 20px;
  }
`;
